import React from 'react';
import styles from './CategoryLink.module.css';

interface CategoryLinkProps {
  label: string;
  href?: string;
  active?: boolean;
  selected?: boolean;
  onClick?: () => void;
  loadingBarWidth?: string; // Width percentage as string (e.g., "45%")
  isActive?: boolean; // Whether this category is active via scroll
}

export const CategoryLink: React.FC<CategoryLinkProps> = ({
  label,
  active = false,
  selected = false,
  loadingBarWidth = '0%',
  isActive = false,
}) => {
  // Show loading bar if either selected (legacy) or actively scrolled to
  const showLoadingBar = selected || isActive;

  return (
    <div className={styles.categoryLinkWrapper}>
      <p
        className={`${styles.categoryLink} ${active ? styles.active : ''} ${selected ? styles.selected : styles.notSelected}`}
        aria-current={active ? 'page' : undefined}
      >
        {label}
      </p>
      {showLoadingBar && (
        <div className={styles.loadingBar} aria-hidden="true">
          <div
            className={styles.loadingBarProgress}
            style={{ width: loadingBarWidth }}
          />
        </div>
      )}
    </div>
  );
};
